import React, { createContext, useContext } from 'react'

const MenuOverlayContext = createContext(false)

export function useMenuOverlayContext() {
  return useContext(MenuOverlayContext)
}

const isInMenuOverlay = true
export function MenuOverlayProvider({ children }) {
  return <MenuOverlayContext.Provider value={isInMenuOverlay}>{children}</MenuOverlayContext.Provider>
}
